import {Avatar} from '../../avatar/avatar';
import {colors} from '../../colors/colors';
import {StatusDot} from '../../status-selector/status-dot';

import {isUnidentifiedRecipient} from '../helpers';
import {UnidentifiedChatAvatar} from '../unidentified-chat-avatar';

import styles from './thread-header-avatar.module.css';

type Props = {
    recipientId: string;
    size: number;
    initials: string;
    type: string;
    avatarUrl: string | null | undefined;
    isActive?: boolean | null | undefined;
    shouldShowStatusDot?: boolean | null | undefined;
};

export function ThreadHeaderAvatar(props: Props) {
    return (
        <div className='inline-block pos-relative'>
            {isUnidentifiedRecipient(props.recipientId) ? (
                <UnidentifiedChatAvatar size={props.size} type={props.type} />
            ) : (
                <Avatar
                    size={props.size}
                    initials={props.initials}
                    type={props.type}
                    avatarUrl={props.avatarUrl}
                />
            )}
            {props.shouldShowStatusDot && (
                <div className={styles['status-indicator']}>
                    <StatusDot color={props.isActive ? colors.success : colors.greyLt} size={10} />
                </div>
            )}
        </div>
    );
}
